module.exports = __webpack_public_path__ + "img/07-green.152e9fd5.svg";